import { useMutation, useQueryClient } from "@tanstack/react-query";

import { applyTemplate } from "@/adapters/api";
import { useStagesLockedGuard } from "@/features/stages/hooks/use-stages-locked-guard.ts";
import { invalidateStageTree } from "@/features/stages/utils/query-keys.ts";

export function useApplyTemplate(constructionId: string | undefined) {
	const queryClient = useQueryClient();
	const guardLocked = useStagesLockedGuard(constructionId);

	return useMutation({
		mutationFn: (templateId: string) => {
			if (!constructionId) throw new Error("missing construction");
			return applyTemplate(constructionId, templateId);
		},
		onSuccess: () => invalidateStageTree(queryClient, constructionId),
		onError: guardLocked,
	});
}
